





















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { DevicePlatform, loginMethodMap } from "@/shared/types";
import { LoginHistoryEvent, devicePlatformMap } from "@/employer/types";
import { PartnerAccountHolderDashboard } from "@/employer/route-names";
import moment from "moment";
import { useLoginHistoryStore } from "@/employer/store/loginHistory";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class LoginHistory extends Vue {
  loginHistoryStore = useLoginHistoryStore();

  selectedEventId: number = null;
  loginMethodMap = loginMethodMap;
  PartnerAccountHolderDashboard = PartnerAccountHolderDashboard;

  @Prop()
  partnerId: number;

  @Prop()
  username: string;

  mounted () {
    if (this.username) {
      this.loginHistoryStore.loadHistory({
        partnerId: this.partnerId,
        username: this.username
      });
    }
  }

  onHover (record: LoginHistoryEvent, active: boolean) {
    if (active) {
      this.selectedEventId = record.loginHistoryId;
    } else if (this.selectedEventId === record.loginHistoryId) {
      this.selectedEventId = null;
    }
  }

  formatTimestamp (timestamp: string) {
    return moment.utc(timestamp).format("llll");
  }

  getPlatform (record: LoginHistoryEvent) {
    return record.platform === DevicePlatform.Unknown && record.isMobile
      ? "Mobile"
      : devicePlatformMap[record.platform];
  }
}
